import {O2dLayoutElement} from "./o2d-layout.element";
import type {Section} from "../types/section.interface";

export type CssVariablesCalculationResult = {
    surplus: number
    countOfAutoAxisCells: number
    watchVariables: string[]
}

export function calculateGridLayoutCssVariables(
    element: O2dLayoutElement,
    gridAxisItems: Section[],
    axis: 'x' | 'y'
): CssVariablesCalculationResult {
    const templateName = element.layoutTemplate.name;

    // Validierung: nur ein GridAxisTemplate in gridAxisItems darf count ein string sein - string ist CSS Variable
    if (gridAxisItems.filter(template => template.count == 'auto').length !== 1) {
        throw new Error('Only one GridAxisTemplate can have a string count');
    }

    if (gridAxisItems.filter(template => typeof template.count == 'number' && template.type == 'fluid' && template.count < 2).length > 0) {
        // TODO: Im 'auto' Bereich muss die berechnete Anzahl mindestens 3 sein - weil sonst repeat mit count 0 raus kommt: Muss von Anke geprüft werden.
        throw new Error('A GridAxis must have either auto or at least 3 cells.');
    }

    const watchVariables: string[] = [];
    const fullSizeOfDefinedGridAxisItems = gridAxisItems
        .filter(template => template.count != 'auto')
        .reduce((sum, template) => {

            const cssVarName = `--${templateName}-${template.sizeCssVariable}`;
            if (!element.computedStyleMap().has(cssVarName)) {
                throw new Error(`CSS Variable ${cssVarName} not set`);
            }
            watchVariables.push(cssVarName);

            const size = parseInt(element.computedStyleMap().get(cssVarName)!.toString(), 10);

            return sum + ((template.count as number) * size)
        }, 0);

    // Auto-sized GridAxisItem
    const autoSizedGridAxisItem = gridAxisItems.find(template => template.count == 'auto')!;

    // Größe des auto-sized GridAxisItems
    const autoSizedCssVarName = `--${templateName}-${autoSizedGridAxisItem.sizeCssVariable}`;
    const sizeOfAutoSizedGridAxisItem = parseFloat(element.computedStyleMap().get(autoSizedCssVarName)!.toString());

    // Größe des GridLayouts in der Achse
    const sizeOfGridLayout = element.getBoundingClientRect()[(axis === 'x' ? 'width' : 'height')];

    // Anzahl der restlichen (auto) Zellen der Achse
    const countOfAutoAxisCells = Math.floor((sizeOfGridLayout - fullSizeOfDefinedGridAxisItems) / sizeOfAutoSizedGridAxisItem);

    // Überhang wird berechnet
    const surplus = sizeOfGridLayout - (fullSizeOfDefinedGridAxisItems + (countOfAutoAxisCells * sizeOfAutoSizedGridAxisItem));

    // remainder CSS Variable setzen
    for (const index in gridAxisItems) {
        const gridAxisItem = gridAxisItems[index]!;
        if (gridAxisItem.type === 'fluid') {
            // setzen den Remainder für das Fluid-GridAxisItem auf die Größe die in der Variablen sizeCssVariable steht
            element.style.setProperty(`--${axis}-remainder-${index}`, `var(--${templateName}-${gridAxisItem.sizeCssVariable})`);
        }
    }

    // const computedAutoSizedGridAxisItemSize = parseInt(element.computedStyleMap().get(`--${autoSizedGridAxisItem.sizeCssVariable}`)?.toString() ?? '0', 10);

    // const axisAutoCellSize = computedAutoSizedGridAxisItemSize + surplus - scrollYRemainder;

    // toggle cell CSS Variable setzen
    element.style.setProperty(`--${axis}-toggle-cell`, `0`);

    return { surplus, countOfAutoAxisCells, watchVariables }
}